import { render, staticRenderFns } from "./ProgramRegistration.vue?vue&type=template&id=63cf37b1&"
import script from "./ProgramRegistration.vue?vue&type=script&lang=js&"
export * from "./ProgramRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports